module.exports = __webpack_public_path__ + "static/media/demo_phone.35f540b0.png";